import React from 'react'
import { useToken } from '../hooks'

const EmptyPage = ({ redirect = '' }) => {
	const { mutate } = useToken()
	mutate(null)
	window.location.href = '/login'
	return <></>
}

export default React.memo(EmptyPage)
